module.exports = __webpack_public_path__ + "img/9.514fcc0d.png";